import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import SyncDisabledIcon from '@mui/icons-material/SyncDisabled'
import ErrorBox from '@/components/shared/boxes/ErrorBox'
import Paragraph from '@/components/shared/typography/Paragraph'
import ConfirmationDialog from '@/javascript/presentation/components/modals/confirmation-dialog'

interface DisconnectModalProps {
  modalOpen: boolean
  apiUrl: string
  apiMethod: string
  onClose: (s: boolean) => void
  onSuccess: (responseJson: any) => void
}

const DisconnectModal: React.FC<DisconnectModalProps> = ({ modalOpen, onClose, apiUrl, apiMethod, onSuccess }) => {
  const [openConfirmationDialog, updateConfirmationDialogVisibility] = useState<boolean>(false)
  const [apiErrorMessage, updateApiErrorMessage] = useState<undefined | string>()

  const disconnectIntegration = async () => {
    try {
      const response = await fetch(apiUrl, {
        method: apiMethod,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })

      const contentType = response.headers.get('content-type')

      if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError("Oops, we haven't got JSON!")
      }

      const responseJson = await response.json()

      if (!response.ok) {
        const errorMessage = `Error ${response.status}: ${responseJson.error}`
        updateConfirmationDialogVisibility(false)
        return updateApiErrorMessage(errorMessage)
      }
      updateConfirmationDialogVisibility(false)
      onClose(false)
      onSuccess(responseJson)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    updateConfirmationDialogVisibility(false)

    return () => {
      updateConfirmationDialogVisibility(false)
    }
  }, [])

  return (
    <>
      <ConfirmationDialog
        modalOpen={modalOpen}
        onClose={onClose}
        onSubmit={() => updateConfirmationDialogVisibility(true)}
        dialogTitleContent="Desconectar integração com ERP"
        cancelBtnProps={{ id: 'omie-disconnect-modal-close-btn', title: 'Cancelar' }}
        confirmationBtnProps={{
          id: 'omie-disconnect-modal-disconnect-btn',
          title: 'Desconectar',
          disabled: openConfirmationDialog,
        }}
      >
        {apiErrorMessage && (
          <ErrorBox errorMessage={apiErrorMessage} onClose={() => updateApiErrorMessage(undefined)} />
        )}

        <Box>
          <Paragraph variant="h6">
            <strong>Ao desconectar sua conta Produttivo do sistema ERP nenhum dado será excluído.</strong>
          </Paragraph>
          <Paragraph>
            Todos os cadastros e atividades que estavam de alguma forma integrados, continuarão na sua conta do
            Produttivo e do ERP.
          </Paragraph>
        </Box>

        <Box sx={{ display: 'flex', gap: '8px' }}>
          <SyncDisabledIcon color="error" />
          <Box>
            <Paragraph>
              <strong>O que muda?</strong>
            </Paragraph>
            <Paragraph>
              A partir de agora qualquer inclusão, alteração ou exclusão não será refletida automaticamente entre os
              sistemas.
            </Paragraph>
          </Box>
        </Box>
      </ConfirmationDialog>

      <ConfirmationDialog
        modalOpen={openConfirmationDialog}
        onClose={(v) => updateConfirmationDialogVisibility(v)}
        onSubmit={() => disconnectIntegration()}
        confirmationBtnProps={{ title: 'Desconectar' }}
      >
        <Paragraph>
          <strong>Tem certeza que deseja desconectar entre os sistemas?</strong>
        </Paragraph>
        <Paragraph>Esse processo não poderá ser desfeito.</Paragraph>
      </ConfirmationDialog>
    </>
  )
}

export default DisconnectModal
